import { useState } from "react"
import { Button } from "reactstrap"

const DisplayToggle = ({
  showLabel = "Show",
  hideLabel = "Hide",
  onToggle,
  children,
}) => {
  const [show, setShow] = useState(false)

  const handleClick = () => {
    setShow(!show)
    if (onToggle) onToggle(!show)
  }

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
      <Button
        type="button"
        size="sm"
        color="light"
        className="d-flex align-items-center gap-1 rounded-pill"
        onClick={handleClick}
        title={show ? hideLabel : showLabel}
        style={{color: '#74788d'}}
      >
        <i className={show ? "fas fa-eye-slash" : "fas fa-eye"}></i>
        <small className="fw-medium">{show ? hideLabel : showLabel}</small>
      </Button>

      {show && children}
    </div>
  )
}

export default DisplayToggle
